<!--充值明细-->
<template>
	<div class="home-main rechargeDetail">
		<div class="main">
			<div class="main_title">
				<span class="title-cn">充值明细</span>
				<span class="title-en">/Recharge Details</span>
			</div>
			<!--筛选部分start-->
			<div class="rechargeDetail-selector">
				<div class="select-item">
					<p>充值时间</p>
					<el-date-picker v-model="searchOption.openingDateStart" value-format="yyyy-MM-dd"  type="date" align="right" :picker-options="pickerOptions1" size="small">
					</el-date-picker>
					<span class="demonstration">到</span>
					<el-date-picker v-model="searchOption.openingDateEnd" value-format="yyyy-MM-dd"  type="date" align="right" :picker-options="pickerOptions2" size="small">
					</el-date-picker>
				</div>
				<div class="select-item selcet-product">
					<p>充值类型</p>
					<el-select v-model="searchOption.customerName" placeholder="请选择">
						<el-option v-for="(item,key) in rechargeType" :key="key" :label="item" :value="key">
						</el-option>
					</el-select>
				</div>
				<el-button size="small" class="warning" @click="search">搜索</el-button>
				<el-button size="small" @click="restSearch">重置</el-button>
			</div>
			<!--筛选部分end-->
			
			<div class="rechargeDetail-main-line"></div>

			<!--订单列表start-->
			<div class="rechargeDetail-main-list">
				<el-table height="100%" :data="tableData" style="width: 100%" stripe>
					<el-table-column width="40">
					</el-table-column>
					<el-table-column label="充值类型">
						<template slot-scope="scope">
							<span>{{ scope.row.type}}</span>
						</template>
					</el-table-column>
					<el-table-column label="充值金额">
						<template slot-scope="scope">
							<span>{{ scope.row.point}}</span>
						</template>
					</el-table-column>
					<el-table-column label="充值时间">
						<template slot-scope="scope">
							<span>{{ scope.row.create_time}}</span>
						</template>
					</el-table-column>
					<el-table-column label="备注">
						<template slot-scope="scope">
							<span>{{ scope.row.note}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!--订单列表end-->
			<div class="pagination">
				<el-pagination
					:disabled="!pagination.use"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.currentPage"
					:page-sizes="[ 20, 30, 50, 100]"
					:page-size="pagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { createGetUrlParams }  from "@/utils/url";
import { getTransaction, getTransactionBySearch }  from "@/api/transaction";
	export default {
		data() {
			return {
				pagination:{
					use: true,
					total:0,
					size:20,
					currentPage:1,
				},
				/*筛选条件-充值时间start*/
				searchOption:{
					openingDateStart:'', //选择开通时间-开始
					openingDateEnd:'',//选择开通时间-结束
					expirationDateStart:'',//选择过期时间-开始
					expirationDateEnd:'',//选择过期时间-结束
					customerName:'',//选择授权客户
					code:''//选择授权码
				},
				pickerOptions1: {
					shortcuts: [{
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 1);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近7天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近90天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近1年',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
							picker.$emit('pick', date);
						}
					}]
				},
				pickerOptions2: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
				/*筛选条件-充值时间end*/
				
				/*筛选条件-币种start*/
				rechargeType:{
					'1':'通用币充值',
					'2':'FastBI币赠送',
					'3':'C9币赠送',
					'4':'FastBI币充值',
					'5':'C9币充值'
				},
				/*筛选条件-币种end*/

				/*表格数据start*/
				tableData: [{
					name: 'FastBI专用币',
					rechargeDate: '2019-01-01 12:23',
					rechargeAmount: '5000.00'
				},{
					name: '通用币',
					rechargeDate: '2019-01-01 12:23',
					rechargeAmount: '5000.00'
				},{
					name: 'c9专用币',
					rechargeDate: '2019-01-01 12:23',
					rechargeAmount: '5000.00'
				}],
				/*表格数据end*/
			};
		},
		mounted(){
			this.getTransactionData()
		},
		methods: {
			handleCurrentChange(val){
				this.pagination.currentPage = val
				this.getTransactionData()
			},
			handleSizeChange(val){
				if(val <= this.pagination.total){
					this.pagination.size = val
					this.getTransactionData()
				}
			},
			getTransactionData(){
				this.loading = true
				let params = {
					p:this.pagination.currentPage,
					count:this.pagination.size,
					category:1
				}
				let result = createGetUrlParams(params)
				if (result.success) {
					getTransactionBySearch(result.data).then(response=>{
						console.log(response);
						
					this.loading = false
						this.pagination.total = response.count | 0
						this.tableData = response.results
					}).catch(()=>{
						this.loading = false
					})
					
				}
			},
			search(){
				this.restPage(false);
				let params = {
					date_start:this.searchOption.openingDateStart,
					date_stop:this.searchOption.openingDateEnd,
					category:1,
					type:this.searchOption.customerName
				}
				let result = createGetUrlParams(params)

				if (result.success) {
					this.loading = true
					getTransactionBySearch(result.data).then(response=>{
						this.tableData = response.results
						this.pagination.total = response.count
						this.loading = false
					}).catch(()=>{
						this.loading = false
					})
					
				}
			},
			restPage(isUsePagination){
				this.pagination.use = isUsePagination
				this.pagination.currentPage = 1
				this.pagination.size = 20
			},
			restSearch(){
				for (const key in this.searchOption) {
					if (this.searchOption.hasOwnProperty(key)) {
						this.searchOption[key] = ''
					}
				}
				this.restPage(true)
				this.getTransactionData()	
			}
		}
	};
</script>

<style lang="scss">
	.rechargeDetail{
		.main{
			display: flex;
			flex-direction:column;
			margin: 0px 14px;
			height: 100%;
			//background-color: #FFFFFF;
			position: absolute;
			top: 0px;
			bottom: 0px;
			left: 0px;
			right: 0px;
			.main_title{
				margin:15px 0;
			}
			.product-selector{
				height: 37px !important;
				background: #fff;
				.selector-center{
					margin-left: 0 !important;
					width: 400px !important;
				}
			}
			.group{
				p{
					margin: 10px 15px 10px 5px!important;
					float: left!important;
					width: 80px!important;
					height: 32px!important;
					line-height: 32px!important;
					text-align: right!important;
				}
			}
			.group .el-input {
				float: left!important;
				margin: 10px 0px!important;
				width: 200px!important;
			}
			.product-main-list{
				flex-grow:1;
				height: 50%;
			}
			.selector-right{
				height: 100% !important;
				line-height: 50px !important;
			}
		}
	}
	/*筛选部分start*/
	.rechargeDetail-selector{
		padding: 18px 0px 20px 24px !important;
		min-width: 980px!important;
		font-size: 12px!important;
		height: 32px!important;
		background:#fff;
	}
	.select-item{
		float: left;
		margin-right: 34px;
		.el-select{
			width: auto;
		}
	}
	.select-item .el-date-editor {
		width: 180px;
	}
	
	.select-item .el-input__inner {
		padding-right: 0px;
	}
	
	.select-item p {
		padding-right: 10px;
		float: left;
		height: 32px;
		line-height: 32px;
		text-align: right;
	}
	.select-input {
		float: left;
		width: 180px;
	}
	
	.selcet-product .el-input__inner {
		width: 150px;
		height: 32px;
		line-height: 32px;
	}
	
	.el-select-dropdown__list {
		padding: 6px 0px 22px 0px;
	}
	
	.el-select-dropdown span {
		font-size: 12px;
	}
	/*筛选部分end*/
	
	.rechargeDetail-main-line {
		width: 100%;
		border-bottom: 1px solid #ededed;
	}
	
	/*订单列表start*/
	.rechargeDetail-main-list {
		min-width: 1100px;
		flex-grow:1;
		height: 50%;
		/*margin-top: 10px;*/
		/*margin:35px 30px 0px 30px;*/
	}
	
	.rechargeDetail-main-list .cell span {
		font-size: 12px;
	}
	/*订单列表end*/
</style>


// WEBPACK FOOTER //
// src/components/financial/rechargeDetails.vue